import React, { useState } from "react";
import {
  ExcuteListPostCode,
  UpdatePostCode,
} from "../services/PostCodeService";
import { useDispatch } from "react-redux";
import { setErrorMessage, setSuccessMessage } from "../slices/messageSlice";
import MessageBox from "./MessageBox";
import { useNavigate } from "react-router-dom";

const PostCodeListTable = ({ postCodeList, reload }) => {
  const dispatch = useDispatch();
  const [selectedPostCode, setSelectedPostCode] = useState({});
  const [showMessage, setShowMessage] = useState(false);
  const navigate = useNavigate();
  const handleToggle = async (e, item) => {
    e.stopPropagation();

    const modeSwicth = item?.isCurrentUsed == 1 ? 0 : 1;
    const response = await UpdatePostCode(
      item.id,
      item?.listConfig,
      item.active,
      modeSwicth
    );
    if (response.status_code == 200) {
      dispatch(setSuccessMessage("Chuyển đổi trạng thái thành công"));
      reload();
    } else {
      dispatch(setErrorMessage(response.message));
    }
  };

  const handleSubmitDelete = async () => {
    const response = await UpdatePostCode(
      selectedPostCode.id,
      selectedPostCode?.listConfig,
      0,
      0
    );
    if (response.status_code == 200) {
      dispatch(setSuccessMessage("Xóa bộ mã thành công"));
      reload();
    } else {
      dispatch(setErrorMessage(response.message));
    }
  };

  const handleCloseMessage = () => {
    setSelectedPostCode(null);
    setShowMessage(false);
  };

  const handleDeleteCode = (item) => {
    setSelectedPostCode(item);
    setShowMessage(true);
  };

  const handleExcuteCode = async (item) => {
    const response = await ExcuteListPostCode(item.id, 1);
    if (response.status_code == 200) {
      dispatch(setSuccessMessage("Duyệt thủ công bộ mã thành công"));
    } else {
      dispatch(setErrorMessage(response.message));
    }
  };

  if (postCodeList.length == 0) {
    return (
      <div className="pt-20 text-xl text-gray-900 dark:text-white"><h2>Không có dữ liệu</h2></div>
    );
  }
  return (
    <div className="overflow-x-auto pt-8 px-8">
      <table className="min-w-full bg-white border border-gray-300 dark:bg-gray-900 dark:border-gray-600">
        <thead>
          <tr className="bg-gray-200 dark:bg-gray-900">
            <th className="py-2 px-4 border">ID</th>
            <th className="py-2 px-4 border">Ngày tạo</th>
            <th className="py-2 px-4 border">Trạng thái</th>
            <th className="py-2 px-4 border">Ngày bắt đầu</th>
            <th className="py-2 px-4 border">Ngày kết thúc</th>
            <th className="py-2 px-4 border">Hành động</th>
          </tr>
        </thead>
        <tbody>
          {postCodeList.map((item) => {
            const { id, createdAt, isCurrentUsed, listConfigDetail } = item;
            const startDate = listConfigDetail[0]?.ngay;
            const endDate = listConfigDetail[listConfigDetail.length - 1]?.ngay;
            if (!item.active) {
              return;
            }
            return (
              <tr
                key={id}
                className="hover:bg-gray-100 dark:hover:bg-gray-700"
                onClick={() => navigate(`/post-code-detail/${item.id}`)}
              >
                <td className="py-2 px-4 border">{id}</td>
                <td className="py-2 px-4 border">
                  {new Date(createdAt).toLocaleDateString()}
                </td>
                <td
                  className="py-2 px-4 border"
                  onClick={(e) => e.stopPropagation()}
                >
                  <label className="inline-flex items-center">
                    <span className="relative">
                      <input
                        type="checkbox"
                        checked={isCurrentUsed}
                        onChange={(e) => handleToggle(e, item)}
                        className="hidden"
                      />
                      <span
                        className={`block w-10 h-6 rounded-full ${
                          isCurrentUsed ? "bg-blue-600" : "bg-gray-400"
                        } transition`}
                      ></span>
                      <span
                        className={`dot absolute left-0 top-0 w-6 h-6 rounded-full bg-white transition-transform ${
                          isCurrentUsed ? "transform translate-x-full" : ""
                        }`}
                      ></span>
                    </span>
                    <span className="ml-4">
                      {isCurrentUsed ? "Đang tự động duyệt" : "Không sử dụng"}
                    </span>
                  </label>
                </td>
                <td className="py-2 px-4 border">{startDate}</td>
                <td className="py-2 px-4 border">{endDate}</td>
                <td
                  className="py-2 px-4 border flex xl:text-base space-x-4 text-xs justify-center"
                  onClick={(e) => e.stopPropagation()}
                >
                  <button
                    className="text-white hover:underline bg-green-600 hover:bg-green-500"
                    onClick={() => handleExcuteCode(item)}
                  >
                    Duyệt thủ công
                  </button>
                  <button
                    className="text-white hover:underline bg-red-600 hover:bg-red-500"
                    onClick={() => handleDeleteCode(item)}
                  >
                    Xóa Bộ Mã
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      {showMessage && (
        <MessageBox
          message="Bạn có chắc muốn xóa bộ mã này?"
          onClose={handleCloseMessage}
          onConfirm={handleSubmitDelete}
          type="warning"
        />
      )}
    </div>
  );
};

export default PostCodeListTable;
